import React, { useState } from "react";
import { Container } from "react-bootstrap";

import styles from "./index.module.scss";
import { HowWeHelpItem } from "../how-we-help-item";

export interface HowWeHelpItemsGroupProps {}

export function HowWeHelpItemsGroup(props: HowWeHelpItemsGroupProps) {
  const [items, setItems] = useState([
    {
      title: "考试中心",
      description:
        "我们提供全面和最先进的考试中心，以满足大连，辽宁和更广泛的东北地区个人和组织的各种需求。",
      image: "/public/1.jpg",
      link: "https://waysglob.com/article.html?id=12"
    },
    // 培训中心，数据中学，实践中心
    {
      title: "培训中心",
      description:
        "我们提供与行业最佳实践保持一致的培训方案，并确保我们的参与者获得最高质量的教育。",
      image: "/public/培训中心.png",
      link: "https://waysglob.com/article.html?id=13"
    },
    {
      title: "数据中心",
      description:
        "我们的数字中心致力于为客户提供在当今快速发展的数字环境中茁壮成长所需的数字工具、技能和知识。",
      image: "/public/数据中心.png",
      link: "https://waysglob.com/article.html?id=14"
    },
    {
      title: "实训基地",
      description:
        "实训基地以行业标准为原则，将考试中心、培训中心、数字中心的专业知识无缝结合，为组织创造一个促进人才发展的动态的生态系统",
      image: "/public/实训基地.png",
      link: "https://waysglob.com/article.html?id=15"
    }
  ]);

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles["title-wrapper"]}>
          <h2>我们能做什么</h2>
          <p>
            更好的展开国际合作，在国际认证中心建立国际行业标准，搭建全球人才数据库，提供全球认证测试，与国际权威机构密切合作，提供符合全球标准的实训与测试
          </p>
        </div>

        <div className={styles["items-wrapper"]}>
          {items.map((item, index) => (
            <HowWeHelpItem
              key={index}
              title={item.title}
              description={item.description}
              image={item.image}
              link={item.link}
            />
          ))}
        </div>
      </Container>
    </div>
  );
}
